<template>
	<app-dropdown
		v-if="vehicles"
		v-model="val"
		:label-key="labelKey"
		:value-key="valueKey"
		:options="vehicles"
		:size="size"
		:disabled="disabled"
		@update:model-value="updateValue">
		Select Vehicle
	</app-dropdown>

	<app-loader v-else theme="light" />
</template>

<script lang="ts" setup>
	import { ref, onMounted, watch } from 'vue'
	import DepotService from '@/services/depot'
	import useAuthStore from '@/stores/auth'
	import type { Vehicle } from '@/data/schema/vehicle'

	const auth = useAuthStore()
	const api = new DepotService()
	const vehicles = ref()
	const val = ref()

	const props = withDefaults(
		defineProps<{
			modelValue: string | string[]
			updateUser?: boolean
			disabled?: boolean
			size?: string
			valueKey?: string
			labelKey?: string | string[]
		}>(),
		{
			updateUser: false,
			disabled: false,
			size: 'medium',
			valueKey: 'id',
			labelKey: 'code'
		}
	)

	const emit = defineEmits(['update:modelValue', 'update:vehicle'])
	function updateValue(value: string | string[]) {
		val.value = value
		const vehicle = vehicles.value.find((obj: Vehicle) => obj.id == val.value)

		if (props.updateUser) {
			auth.setVehicle(vehicles.value.find(vehicle))
		}

		emit('update:modelValue', value)
		emit('update:vehicle', vehicle)
	}

	const loadVehicles = () => {
		api.getLoadVehicles([auth.user!.current_depot ?? ''], 0)
			.then((res) => {
				// filter out empty registration
				vehicles.value = res.data.data.filter((obj: Vehicle) => obj.registration != '')
			})
			.catch((error: any) => {
				console.error(error)
			})
	}

	watch(
		() => props.modelValue,
		(newValue) => {
			val.value = newValue
		}
	)

	watch(
		() => auth.user?.current_depot,
		(newDepot) => {
			if (newDepot) {
				loadVehicles()
			}
		}
	)

	onMounted(() => {
		loadVehicles()
	})
</script>
